import { INewbuilding } from '../../../types/newbuilding';
import { capitalizeFirstLetter } from '../../../utils/formatters/capitalizeFirstLetter';

export const enum SaleType {
  Fz214 = 'f3_214',
  Jsk = 'djsk',
}

export const getSaleDescription = (newbuilding: INewbuilding): string | undefined => {
  const { saleType, isMortgageAllowed } = newbuilding;

  const result: string[] = [];

  if (isMortgageAllowed) {
    result.push('возможна ипотека');
  }

  if (saleType === SaleType.Fz214) {
    result.push('оформление по 214-ФЗ');
  }

  if (saleType === SaleType.Jsk) {
    result.push('оформление по договору ЖСК');
  }

  if (!result.length) {
    return undefined;
  }

  return capitalizeFirstLetter(result.join(', '));
};
